import { Link } from "react-router-dom";
import type { Work } from "@/types";

interface WorkCardProps {
  work: Work;
  index?: number;
}

export default function WorkCard({ work, index = 0 }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group block cursor-pointer"
      style={{ animationDelay: `${(index % 12) * 40}ms` }}
    >
      <article className="animate-fade-up">
        <div className="relative w-full aspect-[3/4] overflow-hidden rounded-lg bg-background-100">
          <img
            src={work.cover}
            alt={`${work.title} - 女性ins大片摄影作品`}
            title={`${work.title} - 时尚女性摄影作品`}
            className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-[11px] font-medium text-secondary-800">
            {work.categoryName}
          </span>
          <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
            <span className="text-xs text-background-50 flex items-center gap-1">
              <i className="ri-arrow-right-up-line"></i>
              查看作品详情
            </span>
          </div>
        </div>
        <div className="pt-3">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {work.title}
          </h3>
          <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {work.author}
            </span>
            <span className="w-1 h-1 rounded-full bg-background-300" />
            <span>{work.date}</span>
          </div>
        </div>
      </article>
    </Link>
  );
}